import { render, staticRenderFns } from "./agent-list.vue?vue&type=template&id=05ff752b&scoped=true&"
import script from "./agent-list.vue?vue&type=script&lang=js&"
export * from "./agent-list.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "05ff752b",
  null
  
)

export default component.exports